export enum KIND {
  text = "text",
  icon = "icon",
  tertiary = "tertiary",
}
